import {
  GetApiIntroducerPortalIntroducerTutorialResponse,
  fetchGetApiIntroducerPortalIntroducerTutorial,
  fetchPutApiIntroducerPortalIntroducerTutorial,
} from '@iwoca/lapi-client/introducer_portal';
import { useQuery } from '@tanstack/react-query';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { IwQueryClient } from 'store/IwQueryClient';
import { TTutorialName } from './useTutorials.types';

export const useGetIntroducerTutorials = (fetchData: boolean = true) => {
  const { introducerId } = useIntroducerData();

  return useQuery<GetApiIntroducerPortalIntroducerTutorialResponse>({
    queryKey: ['fetchGetTutorials', introducerId],
    queryFn: () =>
      fetchGetApiIntroducerPortalIntroducerTutorial({
        introducerId: introducerId as string,
      }),
    enabled: Boolean(introducerId) && fetchData,
  });
};

export const markTutorialAsComplete = async ({
  tutorial,
  introducerId,
}: {
  tutorial: TTutorialName;
  introducerId: string | null;
}) => {
  if (!introducerId) return;

  await fetchPutApiIntroducerPortalIntroducerTutorial({
    introducerId,
    body: {
      data: [
        {
          tutorial,
          completed_at: new Date().toISOString(),
        },
      ],
    },
  });

  IwQueryClient.getOrCreate().invalidateQueries({
    queryKey: ['fetchGetTutorials'],
  });
};
